import {handleOptionClick} from "./handleOptionClick";

export const chatSimulation = () => {
	document.querySelectorAll('.chat-option').forEach(button => {
		button.addEventListener('click', function() {
			const response = this.getAttribute('data-response');
			handleOptionClick(this.textContent, response);
		});
	});
}
